export default ({ environment: { value }, pathname = '', search = '' }) =>
  `${value}${pathname}${search}`;



// WEBPACK FOOTER //
// ./client/helpers/get-environment-location.js